export default "__VITE_ASSET__19158e8d__"